module.exports = __webpack_public_path__ + "img/kv_5_1.b53f6d22.png";